import React from 'react';
import { AtlassianIcon } from '@atlaskit/logo';
import { B300 } from '@atlaskit/theme/colors';
import { NoData } from '..';

interface Props {
  email: string;
}

export const AtlassianEmail = ({ email }: Props) => {
  return (
    <>
      {email?.includes('atlassian.com') ? (
        <span className="flex align-center gap2">
          <AtlassianIcon iconColor={B300} size="small" />
          Atlassian
        </span>
      ) : (
        email || <NoData />
      )}
    </>
  );
};
